import ICMAxios from "../ICMAxios";

const getUomByClient = async () => {
  const response = await ICMAxios.get(`v1/UOM/all`);
  return response.data;
};

const getUomConversionList = async (param: any) => {
  const response = await ICMAxios.post(
    `v1/UOM`, param
  );
  return response.data;
};

const addUOM = async (formData: any) => {
  const response = await ICMAxios.post(`v1/UOM/add`, formData);
  return response.data;
};
const updateUOMStatus = async (formData: any) => {
  const response = await ICMAxios.put(`v1/UOM/status`, formData);
  return response.data;
};
const updateUom = async (formData: any) => {
  const response = await ICMAxios.put(`v1/UOM`, formData);
  return response.data;
};
const uomService = {
  getUomByClient,
  getUomConversionList,
  addUOM,
  updateUOMStatus,
  updateUom,
};

export default uomService;
